import { render, staticRenderFns } from "./BrandInformation.vue?vue&type=template&id=5df39d2a&scoped=true&"
import script from "./BrandInformation.vue?vue&type=script&lang=js&"
export * from "./BrandInformation.vue?vue&type=script&lang=js&"
import style0 from "./BrandInformation.vue?vue&type=style&index=0&id=5df39d2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df39d2a",
  null
  
)

export default component.exports